import type { Definition } from '~/types'

export const PagePlatformDirectory: Definition = {
  contentType: 'PagePlatformDirectory',
  fields: [
    {
      id: 'introText',
      name: 'Intro Text',
      type: 'Text',
      localized: true
    },
    {
      id: 'relatedContent',
      name: 'Related Content',
      type: 'BlockRelatedContent'
    },
    {
      id: 'platformsFoundLabel',
      name: 'Platforms Found Label',
      type: 'Symbol',
      require: true,
      localized: true
    },
    {
      id: 'platformsNoResultsLabel',
      name: 'Platforms No Results Label',
      type: 'Symbol',
      require: true,
      localized: true
    },
    {
      id: 'industryFilterLabel',
      name: 'Industry Filter Label',
      type: 'Symbol',
      require: true,
      localized: true
    },
    {
      id: 'countryFilterLabel',
      name: 'Country Filter Label',
      type: 'Symbol',
      require: true,
      localized: true
    },
    {
      id: 'regionFilterLabel',
      name: 'Region Filter Label',
      type: 'Symbol',
      require: true,
      localized: true
    },
    {
      id: 'defaultCountryFilter',
      name: 'Default Country Filter',
      type: 'GlobalDataCountry',
      localized: true
    }
  ]
}

const GlobalDataPlatformIndustry: Definition = {
  contentType: 'GlobalDataPlatformIndustry',
  fields: [
    {
      id: 'name',
      name: 'Name',
      type: 'Symbol',
      require: true,
      localized: true
    },
    {
      id: 'uniqueId',
      name: 'Unique Id',
      type: 'Symbol',
      require: true,
      localized: false,
      validations: [{ unique: true }]
    }
  ]
}

const Platform: Definition = {
  contentType: 'Platform',
  fields: [
    {
      id: 'name',
      name: 'Name',
      type: 'Symbol',
      require: true,
      localized: false,
      validations: [{ unique: true }]
    },
    {
      id: 'shortDescription',
      name: 'Short Description',
      type: 'Text',
      localized: true
    },
    {
      id: 'industry',
      name: 'Industry',
      type: 'Array',
      subType: 'GlobalDataPlatformIndustry',
      require: true
    },
    {
      id: 'region',
      name: 'Region',
      type: 'Array',
      subType: 'GlobalDataRegion',
      require: true
    },
    {
      id: 'country',
      name: 'Country',
      type: 'Array',
      subType: 'GlobalDataCountry',
      require: true
    },
    {
      id: 'logo',
      name: 'Logo',
      type: 'ModuleMedia',
      imageOptions: {
        recolor: '#ffffff',
        sizes: {
          small: { width: 240, height: 'auto', aspectRatio: null },
          medium: { width: 240, height: 'auto', aspectRatio: null },
          large: { width: 240, height: 'auto', aspectRatio: null }
        }
      },
      require: true
    },
    {
      id: 'link',
      name: 'Link',
      type: 'ModuleLocalizableNavigationLink',
      require: true
    }
  ]
}

export default {
  PagePlatformDirectory,
  GlobalDataPlatformIndustry,
  Platform
}
